import React, { useState, useEffect } from "react";
import { Message } from '../Chatbox';
import ChatBox from "../Chatbox";
import { RecentTracks, LastFMComponent } from "../LastFM";
import { Search, House, MessageSquare, FolderCode, Gamepad2, Signal, CirclePlus, Braces, X, Minus } from 'lucide-react';
import { TwitterLogoIcon, YoutubeLogoIcon } from '@phosphor-icons/react'
import TargetCursor from "../TargetCursor";
import MetaBalls from "../MetaBalls";


const locations = ["src/home", "src/guestbook", "src/about"];
const blurbs = ["hi lol", "whatttts goin on?!", "waow", "HUngry", "#indonesianAndProud", "[object Object]", 
  "my favorite food is pastel goreng", "my favorite dessert is es teler", "please leave a message in my guestbook!"]

const Main: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [cachedSongs, setCachedSongs] = useState<RecentTracks | null>(null);
  const [bunny, setBunny] = useState<string>("bunny_0");
  const [location, setLocation] = useState<string>("src/home");
  const [locationIndex, setLocationIndex] = useState<number>(0);
  const [currBlurb, setCurrBlurb] = useState<number>(0);

  const locationComponents = [
    <Home cachedSongs={cachedSongs} setCachedSongs={setCachedSongs}/>,
    <ChatBox messages={messages} setMessages={setMessages}/>,
    <About />
  ];

  useEffect(() => {
    const blurbTimer = setInterval(() => {
      getRandomBlurb();

      return () => clearInterval(blurbTimer);
    }, 10000);
  }, [])

  useEffect(() => {
    setLocationIndex(locations.indexOf(location));
  }, [location]);

  const getRandomBlurb: () => void = () => {
    setCurrBlurb(Math.floor(Math.random() * (blurbs.length)));
  }

  const handleBunnyClick: () => void = () => {
    setBunny("bunny_1")
  }

  const handleBunnyLetGo: () => void = () => {
    setBunny("bunny_0");
  }

  const parseLocation = (path: string) => {
    const normalized = path.replace(/\/+$/, "");

    const lastSlash = normalized.lastIndexOf("/");

    const prefix = lastSlash !== -1 ? normalized.slice(0, lastSlash) : "";
    const name = lastSlash !== -1 ? normalized.slice(lastSlash + 1) : normalized;

    return (
      <>
        <span className="suffix">/{prefix}/</span>
        {name}
      </>
    );
  }

  return (
    <div className="main">
      <div className="middle">
        <div className="m-marq container">
          <div className="m-marq-content">
            site is still under construction ⚠️⚠️ theres like nothing here .... 
          </div>
        </div>

        <div className="m-middle">
          <div className="m-sidel container">

            <div className="ml-header ">
              <img src="images/sparkle_r.png" alt="star"/>
              <img src="images/sparkle_r.png" alt="star"/>
              <img src="images/sparkle_r.png" alt="star"/>
            </div>

            <div className="ml-header2 container">
              '--...--__nav__--...--'
            </div>
            <div className="ml-nav container-2">
              <div className="nav-header container">
                ..--website--..
              </div>
              <div className="nav-contents container-2 ">
                <button className="nav-item" onClick={() => setLocation("src/home")}>
                  <House size={12}/>
                  {` home`}
                </button>
                <button className="nav-item" onClick={() => setLocation("src/about")}>
                  <Braces size={12}/>
                  {` about`}
                </button>
                <button className="nav-item" onClick={() => setLocation("src/guestbook")}>
                  <MessageSquare size={12}/>
                  {` guestbook`}
                </button>
              </div>

              <div className="nav-header container">
                ..--external--..
              </div>
              <div className="nav-contents container-2 ">
                <button className="nav-item">
                  <a href="https://github.com/miniaturity" target="_blank" rel="noreferrer"><FolderCode size={12}/>
                  {` github`}</a>
                </button>
                <button className="nav-item">
                  <a href="https://miniaturity.itch.io" target="_blank" rel="noreferrer">
                  <Gamepad2 size={12}/>
                  {` itch.io`} </a>
                </button>
                <button className="nav-item">
                  <a href="https://x.com/miniaturity_" target="_blank" rel="noreferrer">
                  <TwitterLogoIcon size={12} />
                  {` twitter`}  </a>
                </button>
                <button className="nav-item">
                  <a href="https://youtube.com/@miniaturity" target="_blank" rel="noreferrer">
                  <YoutubeLogoIcon size={12} />
                  {` youtube`}</a>
                </button>
              </div>

            </div>

            <div style={{ flexGrow: "1" }}>

            </div>
            
            <div className="ml-palette">
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--l-main)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--main)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--d-main)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--border)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--s-br)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--l-bg)"}}>
              </div>
              <div className="mlp-color" 
              style={{ backgroundColor: "var(--bg)"}}>
              </div>
            </div>

          </div>

          <div className="m-mid container">

            <div className="mm-location container ">
              <div className="mml-controls">
                <button className="mml-control">{`<`}</button>
                <button className="mml-control">{`>`}</button>
              </div>
              <div className="mml-bar">{parseLocation(location)}</div>
            </div>

            <div className="mm-lower container-2">
              <div className="mm-header">
                <div className="mmh-search">
                  <Search size={16}/>
                </div>

                <div className="mmh-bar">
                  miniaturity.com
                </div>
              </div>
            </div>

            {locationComponents[locationIndex] || <Placeholder />}

            <div style={{ flexGrow: "1" }}>

            </div>
          

            <div className="mm-footer">
              <img src={`images/b/${bunny}.png`} style={{ marginRight: "-30px"}} alt="me"
                onMouseEnter={handleBunnyClick} onMouseLeave={handleBunnyLetGo}
              />
              <img src="images/r-speech-start.png" className="speech-start" alt=""/>
              <div className="speech-bubble">
                <div className="blurb-content">
                  {blurbs[currBlurb]}
                </div>
              </div>
            </div>
          </div>

          <div className="m-sider container">
            <TargetCursor 
              hideDefaultCursor={false}
              spinDuration={5}
            />
            <div className="mr-header container">
              the gooup
            </div>
            <div className="mr-balls container-2 cursor-target">
              
              <MetaBalls
                color="#f18d87"
                cursorBallColor="#f18d87"
                cursorBallSize={2}
                ballCount={15}
                animationSize={15}
                enableMouseInteraction={true}
                enableTransparency={true}
                hoverSmoothness={0.05}  
                clumpFactor={1}
                speed={0.3}
              />

            </div>

            <div style={{ flexGrow: "1" }}></div>

            <div className="mr-buttons">
              <div className="mrb-1">
                <a href="https://aelita.neocities.org/" target="_blank" rel="noreferrer" className="cursor-target">
                  <img src="https://file.garden/ZF_HpShvAk-Bo5va/neocities/aelita/button1.png" alt="" style={{ height: "31px", width: "88px"}}/>
                </a>
                <a href="https://mayf.pink" target="_blank" rel="noreferrer" className="cursor-target">
                  <img alt="" src="https://mayf.pink/data/main/buttons/__mayf.gif" style={{ height: "31px", width: "88px"}} />
                </a>
                <a href="https://reidlab.pink" target="_blank" rel="noreferrer" className="cursor-target">
                  <img alt="" src="https://mayf.pink/data/main/buttons/reidlab.gif" style={{ height: "31px", width: "88px"}} />
                </a>
              </div>
              
              <div className="mrb-2">
                <a href="https://miniaturity.com" target="_blank" rel="noreferrer" className="cursor-target">
                  <img alt="" src="images/mini.png" style={{ height: "31px", width: "88px"}} />
                </a>
                <a href="https://corru.observer" target="_blank" rel="noreferrer" className="cursor-target">
                  <img alt="" src="https://ivrry.nekoweb.org/assets/images/buttons/corruobserver.gif" style={{ height: "31px", width: "88px"}} />
                </a>
                <a href="https://spax.zone" target="_blank" rel="noreferrer" className="cursor-target">
                  <img alt="" src="https://reidlab.pink/_astro/spax.DJJo1OBg.gif" style={{ height: "31px", width: "88px"}}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="m-footer container-2">
          {`<c> 2025 miniaturity`} {`//`} {`inspired by `} &nbsp;<a href="https://aelita.neocities.org/" target="_blank" rel="noreferrer">https://aelita.neocities.org/ </a>
        </div>

      </div>
    </div>
  )
}

type Status = {
  content: string,
  date: string,
}

async function fetchData(path: string) {
  try {
    const response = await fetch(path);

    if (!response.ok) 
      throw new Error("HTTP Error: Status " + response.status);
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching status" + error);
  }
} 

const Placeholder: React.FC = () => {
  return (
    <div style={{ margin: "6px" }}>
      <div className="mmm-header container">
        <div>404 not found</div>
        <div className="line-container">
          <div className='line'></div>
          <div className='line'></div>
        </div>
        <div className="icon-row">
          <Signal size={16} />
          <CirclePlus size={16} />
        </div>
      </div>

      <div className="mmm-body container-2">
        <div className="row">
          <div style={{ textAlign: "justify", textJustify: "inter-word", display: "block", textAlignLast: "justify", margin: "8px" }}>
            hello. nothing's here for now, check in later!
          </div>
        </div>

      </div>
    </div>
  )
}

type HomeProps = {
  cachedSongs:  RecentTracks | null,
  setCachedSongs: React.Dispatch<React.SetStateAction<RecentTracks | null>>,
}

const rotatingGifs = ["discdisc.gif", "giphy_6.gif"];

const Home: React.FC<HomeProps> = ({ cachedSongs, setCachedSongs }) => {
  const [status, setStatus] = useState<Status>({ content: "Loading..", date: "0/0/0" });
  const [currentGif, setCurrentGif] = useState<string>("giphy_6.gif");
  
  useEffect(() => {
    const chosen = rotatingGifs[Math.floor(Math.random() * rotatingGifs.length)];
    setCurrentGif(chosen);

    fetchData("./data/status.json").then(j => {
      if (j)
        setStatus(j);
    });
  }, []);

  return (
    <>
    <div className="mm-main">

      <div className="mmm-header container">
        <div>about</div>
        <div className="line-container">
          <div className='line'></div>
          <div className='line'></div>
        </div>
        <div className="icon-row">
          <Signal size={16} />
          <CirclePlus size={16} />
        </div>
      </div>
          
      <div className="mmm-body container-2">

        <div className="row">
          <div style={{ textAlign: "justify", textJustify: "inter-word", display: "block", textAlignLast: "justify" }}>
            hi. welcome to Miniaturity.coM. this website is forever wip, but go ahead and press all the buttons and stuff
            anyways. i am a student and game/web dev .. i will post my projects here and some misc stuff. 
            dont forget to sign my guestbook!
          </div>
          <div className="mmm-img">
            <img src={`images/r/${currentGif}`} alt="a random rotating gif"/>
          </div>
        </div>

      </div>

    </div>

    <div className="mm-status-win">
      <div className="mmm-header container">
        <div>status</div>
        <div className="line-container">
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <div className="icon-row">
            <Signal size={16} />
            <CirclePlus size={16} />
        </div>
      </div>
      <div className="mm-status container-2">
        <img src="images/tuyemylove.jpg" alt="profile pic"/>

        <div className="mm-inner-status">
          <div className="is-date container">
            <span>miniaturity</span> 
            <div className="line-container">
              <div className="line"></div>
              <div className="line"></div>
            </div>
            <span className="suffix">{status.date}</span>
          </div>

          <div className="is-content container-2">
            {status.content}
          </div>
        </div>
      </div>

      
    </div>

    <div className="mm-lastfm">
      <LastFMComponent cachedSongs={cachedSongs} setCachedSongs={setCachedSongs}/>
    </div>
    </>
  )
}

const About: React.FC = () => {

  return (
    <>
    <div className="mm-window">
      <div className="mma-header">
        <div>about me</div>
        <div className="icon-row">
          <Minus size={16}/>
          <X size={16}/>
        </div>
      </div>
      <div className="line-2" style={{ marginTop: "2px" }}></div> 
      <div className="mma-body">

        <div className="mma-about">
          <div className="mma-pfp">
            <img src="/images/catpfp.png" alt=""/>
          </div>
          <table>
            <tbody>
              <tr>
                <td>NAME</td>
                <td>mini</td>
              </tr>
              <tr>
                <td>AGE</td>
                <td>???</td>
              </tr>
              <tr>
                <td>IS</td>
                <td>bunny</td>
              </tr>
            </tbody>
          </table>
        </div>

        <fieldset className="mma-albums">
          <legend> fav albums </legend>
          <div className="album-row">
            <img src="/images/a/mm.png" alt=""
            data-title="<b>'Museum Music'</b> <br /> by Edward Skeletrix"
            />
            <img src="/images/a/rw.jpg" alt=""
            data-title="<b>'re:wired'</b> <br /> by kuru"
            />
            <img src="/images/a/stf.jpeg" alt=""
            data-title="<b>'Stay True Forever'</b> <br /> by kuru"
            />
            <img src="/images/a/um.jpg" alt=""
            data-title="<b>'Unmusique'</b> <br /> by Lucy Bedroque"
            />
            <img src="/images/a/jz.jpeg" alt=""
            data-title="<b>'弓长张'</b> <br /> by jackzebra"
            />
            <img src="/images/a/e.png" alt=""
            data-title="<b>'E'</b> <br /> by ecco2k"
            />
            <img src="/images/a/fdlv.jpeg" alt=""
            data-title="<b>'Fête de la Vanille'</b> <br /> by Lucy Bedroque"
            />
            <img src="/images/a/i.jpeg" alt=""
            data-title="<b>'install'</b> <br /> by xaviersobased"
            />
            
          </div>
        </fieldset>

        <div className="mm-window">
          
          <div className="mma-header">
            <div>who are you ?!?!</div>
            <div className="icon-row">
              <Minus size={16}/>
              <X size={16}/>
            </div>
          </div>
          <div className="line-2" style={{ marginTop: "2px" }} /> 
          <div className="mma-body">
            <div className="mma-about-me">
              i am miniaturity.. a web/game dev from NY! i am currently a high school student and studying to be a comp sci major. i speak typescript, java, c#, and python. ummmm ok bye 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="line-2" style={{ marginTop: "2px", margin: "-16px 16px 16px 16px", height: "1px" }}></div> 
    </>
  )
}


export default Main;
